export enum EtaEnum {
  ASAP = "ASAP",
  THREE_MONTHS = "3 months",
  SIX_MONTHS = "6 months",
  NINE_MONTHS = "9 months",
  TWELVE_MONTHS = "12 months",
  NOT_SURE = "Not sure"
}
